module.exports = __webpack_public_path__ + "static/media/seiyouSengan.c401d2ba.png";